import { type SVGProps } from "react"

export function GreenPot(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="76"
            height="116"
            viewBox="0 0 76 116"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g
                id="ConstiPig"
                clipPath="url(#clip_a)"
            >
                <path
                    id="Vector"
                    d="M69.2284 72.4768C69.2284 72.4768 70.1775 73.5781 71.8546 70.2447C73.5682 66.9508 72.2371 74.4519 70.4339 75.989C68.6306 77.5261 68.6143 75.848 68.6143 75.848L69.2284 72.4768Z"
                    fill="#0A604A"
                    fillOpacity="0.8"
                />
                <path
                    id="Vector_2"
                    d="M61.8306 68.8589C61.8306 68.8589 67.1794 67.0286 69.5117 71.9914C71.8454 76.9161 69.592 79.3521 67.8918 80.1304C66.1902 80.9467 61.8306 68.8589 61.8306 68.8589Z"
                    fill="#0A604A"
                    fillOpacity="0.8"
                />
                <path
                    id="Vector_3"
                    d="M17.1048 100.512L18.5357 110.513C18.5357 110.513 21.4956 112.792 26.4024 111.632C31.2713 110.471 28.7478 105.539 28.7478 105.539L17.1048 100.512Z"
                    fill="#0A604A"
                    fillOpacity="0.8"
                />
                <path
                    id="Vector_4"
                    d="M44.0446 104.024L45.0116 109.968C45.0116 109.968 48.1532 111.414 51.6933 110.206C55.2334 108.997 52.8278 101.821 52.8278 101.821L44.0446 104.024Z"
                    fill="#0A604A"
                    fillOpacity="0.8"
                />
                <path
                    id="Vector_5"
                    d="M25.7126 57.2808C25.7126 57.2808 20.1316 49.6101 18.2917 50.0402C16.4518 50.4704 18.6678 62.9775 17.7608 64.9658C16.8538 66.9541 25.7126 57.2808 25.7126 57.2808Z"
                    fill="#0A604A"
                    fillOpacity="0.8"
                />
                <path
                    id="Vector_6"
                    d="M23.7061 59.192C23.7061 59.192 19.4484 52.7883 19.1121 52.6238C18.7758 52.4594 19.412 59.1537 19.1423 61.3934C18.8726 63.6331 23.7061 59.192 23.7061 59.192Z"
                    fill="#0A604A"
                    fillOpacity="0.8"
                />
                <path
                    id="Vector_7"
                    d="M50.2246 103.406L51.7977 110.476C51.7977 110.476 56.7236 113.053 61.526 109.488C62.1698 105.279 62.9558 94.9375 62.9558 94.9375L50.2124 102.681"
                    fill="#10D19F"
                />

                <path
                    id="Piggy"
                    d="M69.3264 81.4776C69.9576 98.9989 53.8205 107.041 36.0912 106.41C18.3999 105.781 7.65285 95.868 8.17016 81.3231C8.68747 66.7782 22.7513 53.9732 39.1898 54.5579C56.6167 55.1396 68.8173 66.9344 69.3264 81.4776Z"
                    fill="#18F0B8"
                />
                <g id="Coin 3">
                    <ellipse
                        id="Ellipse 7"
                        cx="41.5184"
                        cy="9.56154"
                        rx="6.60941"
                        ry="6.6094"
                        transform="rotate(-14.5736 41.5184 9.56154)"
                        fill="#18F0B8"
                    />
                    <path
                        id="&#226;&#130;&#172;"
                        d="M42.4798 6.58477C41.6497 6.22823 40.7796 6.1189 39.7269 6.74379C38.493 7.47625 38.0973 8.79512 38.4143 10.1155L37.6032 10.597L38.0201 11.2994L38.6932 10.8999C38.7495 11.0341 38.828 11.1663 38.9016 11.2902C38.9653 11.3977 39.0291 11.5051 39.0966 11.5991L38.4322 11.9935L38.854 12.7042L39.6392 12.2381C40.6723 13.2117 42.0356 13.464 43.3127 12.7059C44.2964 12.122 44.6245 11.2791 44.7093 10.3013L43.6311 10.2149C43.5334 10.9546 43.3599 11.4487 42.7818 11.7919C42.1087 12.1914 41.3728 12.0918 40.7437 11.5824L42.6162 10.4709L42.1943 9.7603L40.1665 10.964C40.0941 10.8617 40.0304 10.7543 39.9617 10.6386C39.8881 10.5146 39.8146 10.3907 39.7631 10.2647L41.7823 9.06618L41.3653 8.3638L39.5102 9.46504C39.3839 8.70188 39.6279 8.03179 40.2406 7.66812C40.836 7.3147 41.3553 7.364 42.0158 7.63129L42.4798 6.58477Z"
                        fill="#180048"
                    />
                    <animateTransform
                        attributeName="transform"
                        attributeType="XML"
                        type="translate"
                        from="0 0"
                        to="5 60"
                        dur="2s"
                        repeatCount="indefinite"
                    />
                    <animate
                        attributeName="opacity"
                        from="0.5"
                        to="1"
                        dur="2s"
                        begin="0s"
                        repeatCount="indefinite"
                        fill="freeze"
                        keyTimes="0; 0.5; 1"
                        values="0.5; 1; 0.5"
                        calcMode="spline"
                        keySplines="0.42 0 0.58 1; 0.42 0 0.58 1"
                    />
                </g>
                <g id="Coin 2">
                    <ellipse
                        id="Ellipse 7_2"
                        cx="64.8026"
                        cy="27.2302"
                        rx="6.60941"
                        ry="6.6094"
                        transform="rotate(-14.5736 64.8026 27.2302)"
                        fill="#18F0B8"
                    />
                    <path
                        id="&#226;&#130;&#172;_2"
                        d="M67.8993 24.6464C67.3678 23.9159 66.6756 23.3774 65.4514 23.3768C64.0165 23.3761 63.0026 24.3078 62.6006 25.6049L61.6573 25.6044L61.6569 26.4212L62.4396 26.4216C62.4195 26.5657 62.4194 26.7195 62.4193 26.8636C62.4193 26.9885 62.4192 27.1135 62.4292 27.2288L61.6565 27.2284L61.6561 28.0548L62.5693 28.0553C62.96 29.42 64.0031 30.3334 65.4882 30.3341C66.6322 30.3347 67.3449 29.7776 67.9172 28.9803L67.0345 28.3553C66.5726 28.9412 66.1711 29.2774 65.4988 29.2771C64.7161 29.2767 64.1343 28.8152 63.8537 28.0559L66.0312 28.0569L66.0316 27.2305L63.6735 27.2294C63.6635 27.1044 63.6636 26.9795 63.6636 26.845C63.6637 26.7008 63.6638 26.5567 63.6839 26.4222L66.032 26.4233L66.0324 25.6065L63.8749 25.6055C64.1563 24.8849 64.7084 24.4335 65.4208 24.4338C66.1132 24.4342 66.5345 24.7419 66.9657 25.309L67.8993 24.6464Z"
                        fill="#180048"
                    />
                    <animateTransform
                        attributeName="transform"
                        attributeType="XML"
                        type="translate"
                        from="0 0"
                        to="-22 50"
                        dur="2s"
                        repeatCount="indefinite"
                    />
                    <animate
                        attributeName="opacity"
                        from="0.5"
                        to="1"
                        dur="2s"
                        begin="0s"
                        repeatCount="indefinite"
                        fill="freeze"
                        keyTimes="0; 0.5; 1"
                        values="0.5; 1; 0.5"
                        calcMode="spline"
                        keySplines="0.42 0 0.58 1; 0.42 0 0.58 1"
                    />
                </g>
                <g id="Coin 1">
                    <ellipse
                        id="Ellipse 6"
                        cx="42.8107"
                        cy="39.4175"
                        rx="6.60941"
                        ry="6.6094"
                        transform="rotate(-14.5736 42.8107 39.4175)"
                        fill="#18F0B8"
                    />
                    <path
                        id="&#226;&#130;&#172;_3"
                        d="M44.6079 36.2997C43.8442 35.817 43.0022 35.5721 41.8642 36.0236C40.5304 36.5528 39.9321 37.7929 40.0374 39.1468L39.1607 39.4946L39.4619 40.2539L40.1894 39.9652C40.2239 40.1066 40.2806 40.2495 40.3338 40.3835C40.3798 40.4996 40.4259 40.6158 40.4778 40.7192L39.7596 41.0042L40.0643 41.7724L40.9131 41.4356C41.7801 42.5597 43.0868 43.0234 44.4672 42.4757C45.5305 42.0539 45.9872 41.2731 46.2247 40.3208L45.1736 40.0658C44.9607 40.7809 44.7116 41.2415 44.0867 41.4895C43.3592 41.7781 42.6481 41.564 42.107 40.962L44.131 40.159L43.8263 39.3908L41.6343 40.2604C41.5789 40.148 41.5329 40.0319 41.4833 39.9068C41.4301 39.7728 41.377 39.6388 41.346 39.5064L43.5286 38.6405L43.2274 37.8812L41.222 38.6768C41.2174 37.9033 41.5638 37.28 42.2261 37.0172C42.8697 36.7619 43.3748 36.8923 43.985 37.2602L44.6079 36.2997Z"
                        fill="#180048"
                    />
                    <animateTransform
                        attributeName="transform"
                        attributeType="XML"
                        type="translate"
                        from="0 0"
                        to="2 30"
                        dur="2s"
                        repeatCount="indefinite"
                    />
                    <animate
                        attributeName="opacity"
                        from="0.5"
                        to="1"
                        dur="2s"
                        begin="0s"
                        repeatCount="indefinite"
                        fill="freeze"
                        keyTimes="0; 0.5; 1"
                        values="0.5; 1; 0.5"
                        calcMode="spline"
                        keySplines="0.42 0 0.58 1; 0.42 0 0.58 1"
                    />
                </g>
                <path
                    id="VectorNNN"
                    d="M64.4161 74.1752C65.0964 84.4235 51.7326 88.9822 36.9668 88.457C22.2326 87.933 13.1978 82.043 13.5 73.5449C13.8023 65.0468 25.3978 57.6854 39.0887 58.1723C53.6023 58.6662 63.8639 65.669 64.4161 74.1752Z"
                    fill="#18F0B8"
                />

                <path
                    d="M64.4391 73.5306C65.1039 84.2108 51.7326 88.9822 36.9668 88.457C22.2326 87.933 13.2062 81.8077 13.5212 72.9501C13.8362 64.0925 25.4435 56.4026 39.1343 56.8896C53.648 57.3826 63.8996 64.6658 64.4391 73.5306Z"
                    fill="#18F0B8"
                />
                <path
                    id="Vector_9"
                    d="M36.9852 55.6232C39.5735 55.5246 47.0566 55.6764 53.8944 60.0751C54.5859 60.9384 54.5886 61.9297 54.5886 61.9297C54.5886 61.9297 47.519 57.6372 37.2849 57.8832C36.9812 57.8724 36.6843 57.6712 36.6192 57.3639C36.5541 57.0566 36.451 56.7479 36.3466 56.4773C36.2083 56.0912 36.5283 55.6451 36.9852 55.6232Z"
                    fill="#221F1F"
                    fillOpacity="0.8"
                />

                <path
                    id="Vector_10"
                    d="M38.9548 106.055L37.0541 112.468C37.0541 112.468 34.314 113.629 27.4709 112.585C26.3997 110.64 25.4244 101.723 25.4244 101.723L38.9548 106.055Z"
                    fill="#10D19F"
                />
                <path
                    id="Vector_11"
                    d="M10.3943 92.5343C10.3943 92.5343 20.4956 96.0197 25.3306 96.8779C40.8906 99.7187 66.5975 91.9408 68.7585 87.8241C68.7585 87.8241 65.7033 107.464 36.0912 106.41C36.0912 106.41 17.1186 106.536 10.3943 92.5343Z"
                    fill="#10D19F"
                />
                <path
                    id="Vector_12"
                    d="M14.1465 74.6734C12.6537 73.896 5.92053 75.1052 5.92053 75.1052L6.6509 96.2517C6.6509 96.2517 12.4296 97.296 14.9108 95.9355C17.354 94.5737 18.928 90.9317 18.7217 84.9771C18.5153 79.0224 15.6773 75.4522 14.1465 74.6734Z"
                    fill="#10D19F"
                />
                <path
                    id="Vector_13"
                    d="M11.1004 85.5065C11.3108 91.3469 9.31516 96.1558 6.65089 96.2516C4.02594 96.3108 1.72077 91.6539 1.50901 85.8516C1.29859 80.0112 3.29422 75.2023 5.95848 75.1064C8.58479 75.0092 10.89 79.6661 11.1004 85.5065Z"
                    fill="#0A604A"
                />
                <path
                    id="Vector_14"
                    d="M5.28928 88.5786C5.30964 89.0749 4.9151 89.4803 4.42021 89.5008L4.1165 89.49C3.62161 89.5105 3.21754 89.1149 3.19718 88.6185L2.96099 82.4341C2.94063 81.9378 3.33517 81.5324 3.83006 81.5119L4.13378 81.5227C4.62866 81.5022 5.03273 81.8978 5.05309 82.3941L5.28928 88.5786Z"
                    fill="#221F1F"
                    fillOpacity="0.8"
                />
                <path
                    id="Vector_15"
                    d="M8.77791 88.8169C8.79827 89.3132 8.40373 89.7185 7.90884 89.739L7.60513 89.7282C7.11024 89.7488 6.70617 89.3532 6.68581 88.8568L6.44963 82.6724C6.42927 82.176 6.8238 81.7707 7.31869 81.7502L7.62241 81.761C8.1173 81.7405 8.52136 82.1361 8.54172 82.6324L8.77791 88.8169Z"
                    fill="#221F1F"
                    fillOpacity="0.8"
                />
                <path
                    id="Vector_16"
                    d="M17.9658 70.9586C17.33 72.804 18.2101 74.7796 19.9375 75.3748C21.6635 76.0081 23.5996 75.0094 24.2354 73.164C24.8713 71.3185 23.9912 69.3429 22.2638 68.7478C20.5364 68.1526 18.6017 69.1131 17.9658 70.9586Z"
                    fill="white"
                    fillOpacity="0.8"
                />
                <path
                    id="Vector_17"
                    d="M18.2655 71.0838C17.7584 72.5145 18.4636 74.0645 19.814 74.57C21.1658 75.0375 22.6749 74.2905 23.1819 72.8599C23.6889 71.4292 22.9838 69.8792 21.6334 69.3737C20.2829 68.8681 18.8105 69.6545 18.2655 71.0838Z"
                    fill="#180048"
                />
                <path
                    id="Vector_18"
                    d="M15.6256 70.4942C14.9369 71.6896 13.7356 72.3331 12.9153 71.8846C12.095 71.4361 11.9905 70.098 12.6806 68.8645C13.3693 67.669 14.5706 67.0255 15.3909 67.474C16.2112 67.9226 16.3157 69.2606 15.6256 70.4942Z"
                    fill="white"
                    fillOpacity="0.8"
                />
                <path
                    id="Vector_19"
                    d="M15.029 70.1681C14.5002 71.1405 13.5335 71.6017 12.899 71.2742C12.2658 70.9085 12.1884 69.8764 12.7172 68.904C13.2459 67.9316 14.2126 67.4704 14.8472 67.7979C15.4818 68.1255 15.5564 69.2337 15.029 70.1681Z"
                    fill="#180048"
                />
                <path
                    id="Vector_20"
                    d="M22.7927 70.9779C22.7805 71.3205 22.5053 71.5776 22.1636 71.5655C21.8219 71.5533 21.5657 71.2773 21.5779 70.9347C21.59 70.592 21.8653 70.3349 22.2069 70.347C22.5486 70.3592 22.8035 70.6733 22.7927 70.9779Z"
                    fill="white"
                    fillOpacity="0.8"
                />
                <path
                    id="Vector_21"
                    d="M14.8446 68.9415C14.7632 69.0911 14.6086 69.1618 14.4215 69.0789C14.2724 68.9974 14.2019 68.8423 14.2846 68.6547C14.3659 68.5051 14.5205 68.4343 14.7076 68.5172C14.8188 68.5974 14.8879 68.7905 14.8446 68.9415Z"
                    fill="white"
                    fillOpacity="0.8"
                />
            </g>
            <defs>
                <clipPath id="clip_a">
                    <rect
                        width="71.4881"
                        height="113.395"
                        fill="white"
                        transform="translate(4.03027) rotate(2.03695)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}
